'use client';
import { typeAboutTurnCom } from './types/TypesDocsId';
// import { useState } from 'react';
// import { useAppDispatch } from '@/lib/RTK/hooks';
// import { setDocTurnStatus } from '@/lib/RTK/features/DocIdSlice';
// import { useRouter } from 'next/navigation';
import { formatNameDoctor } from '@/constant/scripts';
import { IoLocationSharp } from 'react-icons/io5';
import TurnModals from './turn-modals';
import { CiClock2 } from 'react-icons/ci';
import jalaali from 'jalaali-js';
import { useAppDispatch } from '@/lib/RTK/hooks';
import { setUpdateTurnsToFirst } from '@/lib/RTK/features/AdmissionSlice';

export default function AboutTurnCom(props: typeAboutTurnCom) {
    // const router = useRouter();
    const {
        id,
        turns,
        address,
        first,
        idDoctor,
        name,
        nameDoc,
        time,
        // turnSatus,
    } = props;
    const dispatch = useAppDispatch();

    const todayJalali = (() => {
        const gDate = new Date();
        const jDate = jalaali.toJalaali(gDate);
        return `${jDate.jy}/${String(jDate.jm).padStart(2, '0')}/${String(
            jDate.jd,
        ).padStart(2, '0')}`;
    })();

    return (
        <div className="w-full">
            <div className="flex flex-col text-[#222222A3] gap-2 pt-1 text-sm items-start justify-start">
                <p className='text-[#222222] text-base font-medium'>{id === 'matab' ? 'مطب شخصی' : name}</p>
                <p>
                    <IoLocationSharp className="text-base lg:!text-xl i_f me-1" />
                    {address}
                </p>
                {first && (
                    <TurnModals
                        disabled={turns === 'no'}
                        docName={String(formatNameDoctor(nameDoc))}
                        docid={idDoctor}
                        clinic={String(id)}
                        trigger={
                            <div
                                onClick={() => {
                                    dispatch(setUpdateTurnsToFirst(true));
                                }}
                                className="flex justify-start gap-2 items-center w-full py-2"
                            >
                                <p className="text-[#222222] font-normal flex gap-1 items-center">
                                    {' '}
                                    <CiClock2 /> اولین نوبت آزاد:
                                </p>
                                <p className="font-normal text-[#222222]">
                                    {first && first.includes(todayJalali)
                                        ? `امروز ساعت ${time} `
                                        : first}
                                </p>
                            </div>
                        }
                    />
                )}
            </div>

            <div className="flex justify-end pt-3">
                <TurnModals
                    disabled={turns === 'no'}
                    docName={String(formatNameDoctor(nameDoc))}
                    docid={idDoctor}
                    clinic={String(id)}
                />
            </div>
        </div>
    );
}
